import { useState } from "react";
import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function LabSamplesDetailsViewModel(logout, id, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [labSample, setLabSample] = useState({
    lab_id: null,
    barcode: null,
    manufactured_product_id: null,
    lot_number: null,
    plu: null,
    product_name: null,
    weight_in_kg: null,
    weight_in_lbs: null,
    piece_count: null,
  });
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  const getLabSampleDetails = async function () {
    let callResult = await makeGetApiCall(`lab-samples/${id}`);

    if (callResult.success) {
      setLabSample(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const getLabsForDropdown = async function () {
    let callResult = await makeGetApiCall(`laboratoriesForDropdown`);

    if (callResult.success) {
      setLabs(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const updateLabSample = async function (payload) {
    setInProgress(true);
    let callResult = await makePostApiCall(
      `lab-samples/${id}`,
      {
        ...payload,
        status: payload.status.value,
        lab_id: payload.laboratory.value,
        laboratory: null,
      },
      "multipart/form-data"
    );

    if (callResult.success) {
      await getLabSampleDetails();
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setInProgress(false);
      return true;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setInProgress(false);
    return false;
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    loading,
    labSample,
    getLabSampleDetails,
    updateLabSample,
    inProgress,
    labs,
    getLabsForDropdown,
  };
}
